<template>
    <div>
        <img class="image-preview" :src="showImage" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
const setImgSrc = async (el, binding) => {
    if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
        let imageUrl = binding.value

        try {
            let response = await request({
                url: `/files/${imageUrl}`,
                responseType: 'arraybuffer',
            })

            let mimeType = response.headers['content-type'].toLowerCase()

            let imgBase64 = new Buffer(response.data, 'binary').toString(
                'base64'
            )

            if (el.tagName === 'IMG') {
                el.src = `data:${mimeType};base64,${imgBase64}`
            } else if (el.tagName === 'VIDEO') {
                el.poster = `data:${mimeType};base64,${imgBase64}`
            } else {
                el.style.backgroundImage = `url('data:${mimeType};base64,${imgBase64}')`
            }
        } catch (error) {
            el.style.backgroundImage = imageUrl
        }
    }
}

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['selectedItem']),

        showImage() {
            return `${process.env.VUE_APP_API_URL}files/customers/${this.selectedItem}`
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        item: {
            type: Object,
            default: null,
        },

        timelineImage: {
            type: String,
            default: null,
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {},
}
</script>
